import React from 'react';
import { Helmet } from 'react-helmet';
import MetaTags from './MetaTags';
import { generatePageSEO } from '../../utils/SEOUtils';

const SHARE_IMAGE = 'https://www.bkfc.com/assets/images/bkfc-social-share.jpg';
const HOME_URL = 'https://www.bkfc.com';

/**
 * The homepage's social and SEO tags. Old `/?channel=<slug>` share links redirect to the title's
 * watch page (Homepage), so the homepage only ever describes itself.
 */
const DynamicMetaTags = () => {
  const { title, description } = generatePageSEO('homepage');
  return (
    <>
      <MetaTags
        title={title}
        description={description}
        image={SHARE_IMAGE}
        url={HOME_URL}
        type="website"
      />
      <Helmet>
        <link rel="canonical" href={HOME_URL} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="BKFC+" />
      </Helmet>
    </>
  );
};

export default DynamicMetaTags;
